import type { SubmitEvaluationBody } from "@shared-kernel/application/ports/external-provider/external-provider-repository";
import type { ObjectiveDetailVM, TrainingItemAppraisalVM } from "@academy-context/read/domain/types/shared/training-item-evaluation";
import { TrainingItemEvaluationForm } from "@academy-context/primary/shared/training-item-evaluation/training-item-evaluation-form.content";
import type { Nullable } from "@shared-kernel/core/types/nullable";

interface Props {
  participationId: Nullable<string>;
  objectives: ObjectiveDetailVM[];
  appraisal: Nullable<TrainingItemAppraisalVM>;
  onSubmit: (participationId: string, body: SubmitEvaluationBody) => Promise<void>;
}

// Le partenaire rend exactement l'acte du conseiller — mêmes objectifs, mêmes appréciations, même
// règle de groupe — sur son endpoint à jeton. Seul l'habillage lui appartient.
export const EvaluationSection = ({ participationId, objectives, appraisal, onSubmit }: Props) => {
  // Sans participation, il n'y a pas d'élément de formation à évaluer ; sans objectif assigné, rien
  // à noter.
  if (!participationId || objectives.length === 0) return null;

  return (
    <section className="space-y-4">
      <h4 className="font-semibold text-white">Évaluation</h4>
      <TrainingItemEvaluationForm objectives={objectives} appraisal={appraisal} onSubmit={body => onSubmit(participationId, body)} />
    </section>
  );
};
